import {createAsyncThunk} from "@reduxjs/toolkit";
import type {EventHashedID} from "@Components/events/events.types";
import type {EventOneClickPromoBackendResponse} from "@Panels/event-one-click-promotion-panel/event-one-click-promotion-panel.types";
import {getEmailMarketingCampaignSendBalance} from "@Libraries/email-campaigns-library";

export const getEventOneClickPromotionInfo = createAsyncThunk<EventOneClickPromoBackendResponse, EventHashedID>('getEventOneClickPromotionInfo', (eventHashedId: EventHashedID) => {
    return window.PMW.readLocal('event/getEventOneClickPromotionInfo', {
        event_hid: eventHashedId
    })
});

/** Re-reads the team's email-send balance, e.g. after the user buys more sends. */
export const refreshOneClickEmailSends = createAsyncThunk<number, string, {rejectValue: unknown}>('refreshOneClickEmailSends', async (idEmailMarketingCampaign: string, {rejectWithValue}) => {
    try {
        return await getEmailMarketingCampaignSendBalance(idEmailMarketingCampaign);
    } catch (err: unknown) {
        return rejectWithValue(err);
    }
});
